
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Candidate } from "@/types/candidate";

export const fetchCandidatesFromDB = async (): Promise<Candidate[]> => {
  try {
    const { data, error } = await supabase
      .from('candidates')
      .select('id, name, email, function, skills, match_score, status');
    
    if (error) {
      throw error;
    }

    if (data) {
      // Transform data to match the Candidate interface
      const transformedData: Candidate[] = data.map(item => ({
        id: item.id,
        name: item.name,
        email: item.email,
        function: item.function || "",
        skills: item.skills || [],
        match_score: item.match_score || 0,
        status: item.status || ""
      }));
      
      return transformedData;
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching candidates:", error);
    toast({
      title: "Failed to load candidates",
      description: "Using sample data instead.",
      variant: "destructive",
    });
    
    // Return mock data as fallback
    return getMockCandidates();
  }
};

const getMockCandidates = (): Candidate[] => {
  return [
    {
      id: "1",
      name: "Amelia Torres",
      email: "amelia.torres@example.com",
      function: "AI Researcher",
      skills: ["Flask", "Node.js", "GraphQL"],
      match_score: 70,
      status: "looking"
    },
    {
      id: "2",
      name: "Amelia White",
      email: "amelia.white@example.com",
      function: "UI/UX Designer",
      skills: ["Linux", "Python", "Swift", "C++"],
      match_score: 80,
      status: "open"
    },
    {
      id: "3",
      name: "Ava Adams",
      email: "ava.adams@example.com",
      function: "Full Stack Developer",
      skills: ["Spring Boot", "React", "Docker"],
      match_score: 60,
      status: "unavailable"
    },
    {
      id: "4",
      name: "Benjamin Smith",
      email: "benjamin.smith@example.com",
      function: "Software Engineer",
      skills: ["JavaScript", "TypeScript", "React", "Node.js"],
      match_score: 75,
      status: "looking"
    }
  ];
};
